import React, { useState } from 'react';
import { BottomSheet } from './BottomSheet';
import {
  PERSON_OPTIONS,
  personInheritanceText,
  personReadout,
  personSelectValue,
} from '../../utils/personMode';
import { PERSON, PERSON_INHERITED, PERSON_NO_DEFAULT } from '../../utils/writerCopy';
import './PersonControl.css';

/**
 * Narrative Person picker (#1183). Not Whose head.
 * Wide: native select. Narrow: chip opens the same options.
 * Inherited clears the scene override so book or chapter shows.
 */
export default function PersonControl({
  person,
  onChange,
  variant = 'select',
  id = 'person-mode',
  disabled = false,
  label = PERSON,
  hideNoBookDefault = false,
}) {
  const [sheetOpen, setSheetOpen] = useState(false);
  const value = personSelectValue(person);
  const inheritedText = personInheritanceText(person);
  const inherited = hideNoBookDefault && inheritedText === PERSON_NO_DEFAULT
    ? ''
    : inheritedText;
  const readout = personReadout(person);

  const pick = (next) => {
    if (disabled) return;
    onChange?.(next);
    setSheetOpen(false);
  };

  const picker = (
    <div className="person-picker" data-testid="person-picker">
      <label className="person-picker__field" htmlFor={id}>
        <span>{label}</span>
        <select
          id={id}
          value={value}
          disabled={disabled}
          onChange={(e) => pick(e.target.value)}
        >
          <option value="">{PERSON_INHERITED}</option>
          {PERSON_OPTIONS.map((mode) => (
            <option key={mode.value} value={mode.value}>{mode.label}</option>
          ))}
        </select>
      </label>
      {inherited && (
        <p className="person-picker__chip" data-testid="person-inheritance">{inherited}</p>
      )}
    </div>
  );

  if (variant !== 'chip') return picker;

  return (
    <div className="person-mode">
      <button
        type="button"
        className="person-chip"
        aria-expanded={sheetOpen}
        aria-haspopup="dialog"
        aria-label={`${label}: ${readout}`}
        data-testid="person-chip"
        disabled={disabled}
        onClick={() => setSheetOpen(true)}
      >
        <span className="person-chip__primary">{label}</span>
        <span className="person-chip__secondary" data-testid="person-inheritance">{readout}</span>
      </button>
      <BottomSheet
        isOpen={sheetOpen}
        onClose={() => setSheetOpen(false)}
        title={label}
      >
        <div className="person-sheet" data-testid="person-sheet">
          {picker}
        </div>
      </BottomSheet>
    </div>
  );
}
